import NewsLetterRepository from './NewsLetterRepoistory';

const repositories = {
    newsletter: NewsLetterRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};
